import React from "react";
import { PieChart } from "react-minimal-pie-chart";
import "./MyChart.css";

const toAmount = (value) => parseFloat(value || 0);

const Chart = (props) => {
  const title = props?.title || "FUNDS";
  const total = toAmount(props?.totalPaymentRequests);
  const pending = toAmount(props?.pendingPaymentRequests);
  const approved = toAmount(props?.approvedPaymentRequests);
  const rejected = toAmount(props?.rejectedPaymentRequests);

  const data = [
    { title: `Pending ${title}`, value: pending, color: "#EFC517" },
    { title: `Approved ${title}`, value: approved, color: "#10b981" },
    { title: `Rejected ${title}`, value: rejected, color: "#ef4444" },
  ];

  return (
    <div className={`capping ${props?.className || ""}`.trim()}>
      <h3 className="capping-title">{title}</h3>
      <div className="cappingGraphDiv">
        <div style={{ height: "120px" }}>
          <PieChart
            animate
            animationDuration={2000}
            data={data}
            lineWidth={30}
            paddingAngle={2}
            label={({ dataEntry }) => `${Math.round(dataEntry.percentage)}%`}
            labelStyle={{
              fill: "var(--textMuted)",
              fontFamily: "sans-serif",
              fontSize: "8px",
              fontWeight: "bold",
            }}
          />
        </div>
        <div className="cappingAbout">
          <div>
            <span style={{ background: "#EFC517" }} />
            <p>Pending</p>
          </div>
          <div>
            <span style={{ background: "#10b981" }} />
            <p>Approved</p>
          </div>
          <div>
            <span style={{ background: "#ef4444" }} />
            <p>Rejected</p>
          </div>
        </div>
      </div>

      <div className="cappingDetails cappingDetailsDashboard capping-footer">
        <div>
          <h3>{total.toFixed(2)}</h3>
          <p>Total</p>
        </div>
        <div>
          <h3>{pending.toFixed(2)}</h3>
          <p>Pending</p>
        </div>
        <div>
          <h3>{approved.toFixed(2)}</h3>
          <p>Approved</p>
        </div>
        <div>
          <h3>{rejected.toFixed(2)}</h3>
          <p>Rejected</p>
        </div>
      </div>
    </div>
  );
};

export default Chart;
